import React, { Fragment, useMemo, useState } from 'react';
import classnames from 'classnames';
import { FiServer, FiUser } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { can } from '../can';
import { routes } from '../routes';

import { roles } from '../constants';

import api from '../utils/api';
import { useQuery } from '../utils/query';

import Pagination from '../components/common/Pagination';
import PageHeader from '../components/common/PageHeader';

import { List, Header, Body, Row, Cell } from '../components/common/List';
import Button from '../components/common/Button';
import Select, { indexToOptions } from '../components/common/Select';

import { Loading } from './PageStatus';

import css from './Segments.css';

const Segments = (props) => {
  const query = useQuery(props.location, props.history);
  const { user } = api.auth();
  const segmentIndexQuery = useMemo(
    () => ({ ...query.obj, sortBy: 'id', orderAsc: false, relations: 'clients,users' }),
    [query.obj]
  );
  const { index, actions } = api.segments.index(segmentIndexQuery);
  const { actions: clientsActions } = api.clients.index(null, { lazy: true });
  const isAdmin = user.role == roles('admin');
  const getClients = async (search) =>
    [
      { value: '', label: 'Todos los grupos' },
      { value: 'false', label: 'Solo grupos globales' },
    ].concat(indexToOptions(await clientsActions.get({ search, perPage: 50 })));
  return (
    <main>
      <PageHeader title="Grupos">
        {can(user, 'create', 'segments') && (
          <Button noMargin to={routes('newSegment')}>
            Nuevo
          </Button>
        )}
      </PageHeader>
      <div className={css.toolbar}>
        {can(user, 'index', 'clients') && (
          <Select
            className={css.select}
            label="Filtrar grupos"
            name="scopeToClientId"
            value={query.get('scopeToClientId')}
            onChange={query.set}
            placeholder="Todos"
            loadOptions={getClients}
          />
        )}
      </div>
      {index.loaded ? (
        <Fragment>
          <List>
            <Header>
              <Cell head className={css.id}>
                ID
              </Cell>
              <Cell head className={css.nameHeader}>
                Nombre
              </Cell>
              {isAdmin ? (
                <Cell head className={css.scope}>
                  Clientes
                </Cell>
              ) : null}
            </Header>
            <Body>
              {index.data.size ? (
                index.data
                  .toJS()
                  .slice()
                  .sort((a, b) => Number(b.id) - Number(a.id))
                  .map((segment, i) => {
                  const to = routes('segment', { id: segment.id });
                  const clientLabels = [];
                  if (segment.scopeToClientId) {
                    clientLabels.push({
                      id: segment.scopeToClientId,
                      name: segment.scopeToClientName || segment.scopeToClientId,
                      match: 'scope',
                    });
                  }
                  const assignedClients = Array.isArray(segment.clients) ? segment.clients : [];
                  assignedClients.forEach((assignedClient) => {
                    const id = assignedClient && typeof assignedClient === 'object' ? assignedClient.id : assignedClient;
                    const name =
                      assignedClient && typeof assignedClient === 'object'
                        ? assignedClient.name || assignedClient.id
                        : assignedClient;
                    if (id == null || clientLabels.some((item) => String(item.id) === String(id))) return;
                    clientLabels.push({ id, name, match: 'assigned' });
                  });
                  return (
                    <Row key={`segment-row-${i}`}>
                      <Cell className={css.id}>
                        <Link to={to}>{segment.id}</Link>
                      </Cell>
                      <Cell>
                        <Link className={css.name} to={to}>
                          {segment.name}
                        </Link>
                      </Cell>
                      {isAdmin ? (
                        <Cell className={css.scope}>
                          <div className={css.clients}>
                            {clientLabels.map((client) => (
                              <Link
                                key={`segment-${segment.id}-client-${client.id}`}
                                className={classnames(css.clientLabel, client.match === 'scope' ? css.clientScope : css.clientAssigned)}
                                to={routes('client', { id: client.id })}>
                                {client.match === 'scope' ? <FiUser aria-hidden="true" /> : <FiServer aria-hidden="true" />}
                                {client.name}
                              </Link>
                            ))}
                            {!clientLabels.length ? <span className={css.noClients}>Sin clientes</span> : null}
                          </div>
                        </Cell>
                      ) : null}
                    </Row>
                  );
                })
              ) : (
                <Row>
                  <Cell center colSpan={isAdmin ? 3 : 2}>
                    <p style={{ padding: '1rem 0' }}>
                      <small>No hay grupos que coincidan con esta busqueda</small>
                    </p>
                  </Cell>
                </Row>
              )}
            </Body>
          </List>
          {index.pageInfo && <Pagination {...index.pageInfo.toJS()} onChange={query.setPage} />}
        </Fragment>
      ) : (
        <Loading compact />
      )}
    </main>
  );
};

export default Segments;
